import { set } from "date-fns";
import useLocalState from "./useLocalState";

export function useSession() {
  //const session = useState("session", () => "");  // without localStorage
  const session = useLocalState("session", () => ""); // with localStorage (persisted)
  const loginname = useLocalState("loginname", () => ""); // with localStorage (persisted)

  function setSession(newSession: string) {
    //console.log("Setting session", newSession);
    useGqlHeaders({ "X-Parse-Session-Token": newSession });
    session.value = newSession;
  }
  function clearSession() {
    useGqlHeaders({ "X-Parse-Session-Token": "" });
    session.value = "";
  }
  function hasSession() {
    //console.log("Checking hasSession", session.value);
    return session.value && session.value.length > 0;
  }

  // Login the user with the server
  async function login(email: string, password: string) {
    try {
      const result = await GqlLogIn({ email, password });
      if (result?.logIn?.viewer.sessionToken) {
        setSession(result.logIn.viewer.sessionToken);
        loginname.value = email;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  // Logout the user from the server
  async function logout() {
    try {
      await GqlLogOut();
      clearSession();
      loginname.value = "";
      return true;
    } catch (e) {
      return false;
    }
  }

  // Retrieve the session token from the server
  async function getServerSession() {
    try {
      const result = await GqlViewer();
      if (result?.viewer.sessionToken) {
        return result.viewer.sessionToken;
      }
      return "";
    } catch (e) {
      return "";
    }
  }

  // Validate the session token with the server
  async function hasValidServerSession(shouldSave = false) {
    const serverSession = await getServerSession();

    if (serverSession !== "") {
      if (shouldSave) {
        setSession(serverSession);
      }
      return true;
    }
    return false;
  }

  return {
    session,
    loginname,
    setSession,
    hasSession,
    clearSession,
    hasValidServerSession,
    login,
    logout,
  };
}
